import React from "react"

// noinspection ES6UnusedImports
import CONTROL_CSS from "./control-ui.css"

class ControlUI extends React.Component {

    state = {
        phong : false
    };

    togglePhong = ev => {

        this.setState(
            {
                phong: !this.state.phong
            },
            () => this.props.togglePhong(this.state.phong)
        )
    };

    render()
    {
        const { phong } = this.state;

        return (
            <div id="control-ui">
                <button
                    type="button"
                    onClick={ this.togglePhong }
                >
                    {
                        phong ? "Phong" : "Sketch"
                    }
                </button>
            </div>
        )
    }
}

export default ControlUI
